import React, {useState} from 'react'
import QualityCheckParameterForm from './QualityCheckParameterForm';
import QualityCheckParameterList from './QualityCheckParameterList';

const QualityCheckParameter = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <QualityCheckParameterForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <QualityCheckParameterList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
    </>
  )
}

export default QualityCheckParameter
